<template>
  <div>
    <el-table
      ref="elTable"
      :key="tableKey"
      class="table-card"
      :data="tableData"
      :height="tableHeight"
      border
      @selection-change="handleSelectionChange"
    >
      <el-table-column
        align="center"
        type="selection"
        width="55"
      />
      <el-table-column :label="$t('operationCenter.ind')" align="center" width="60px">
        <template v-slot="scope">
          <span>{{ (pageNumber - 1) * pageSize + scope.$index + 1 }}</span>
        </template>
      </el-table-column>
      <el-table-column
        v-for="(item, index) in currentColumns"
        :key="index"
        :align="item.fixed"
        :label="item.label"
        :prop="item.prop"
        :show-overflow-tooltip="true"
        :min-width="item.width"
        :class-name="'ellipsis'"
      >
        <template v-slot="scope">
          <div v-if="item.prop === 'businessType'">
            {{
              scope.row[item.prop] === 0
                ? $t('basicData.CourierSystemBusiness')
                : scope.row[item.prop] === 1 ? $t('basicData.CollectionSystemBusiness') : ''
            }}
          </div>
          <!--货物类型-->
          <div v-else-if="item.prop === 'cargoType'">
            <span>{{ CARGO_TYPE[scope.row[item.prop]] && CARGO_TYPE[scope.row[item.prop]].name || '' }}</span>
          </div>
          <!-- 揽收方式-->
          <div v-else-if="item.prop === 'collectType'">
            {{
              scope.row[item.prop] === 1
                ? $t('collectionCenter.dropOff')
                : scope.row[item.prop] === 2 ? $t('collectionCenter.doorPickUp') : ''
            }}
          </div>
          <div v-else>{{ scope.row[item.prop] }}</div>
        </template>
      </el-table-column>
      <el-table-column
        v-for="(item, ind) in getCurrentColumns"
        :key="ind + 100"
        :align="item.fixed"
        :label="item.label"
        :prop="item.prop"
        :show-overflow-tooltip="true"
        :min-width="item.width"
        :class-name="'ellipsis'"
      >
        <template v-slot="scope">
          <div>{{ scope.row[item.prop] }}</div>
        </template>
      </el-table-column>
      <template v-if="isWithdraw">
        <!--      对账状态-->
        <el-table-column
          :label="$t('receivablePayable.ReconciliationStatus')"
          prop="isGenReceipt"
          width="140"
          fixed="right"
        >
          <template v-slot="scope">
            <span>{{ scope.row.isGenReceipt ? $t('receivablePayable.reconciled') : $t('receivablePayable.pending') }}</span>
          </template>
        </el-table-column>
        <!--操作-->
        <el-table-column
          :label="$t('basicData.operate')"
          align="center"
          width="140"
          fixed="right"
          :show-overflow-tooltip="true"
        >
          <template v-slot="scope">
            <el-popconfirm
              :title="$t('receivablePayable.AreYouSureYouWantToWithdraw')"
              @confirm="recall(scope.row)"
            >
              <!--
                用户只能操作自身数据
                isGenReceipt为false的时候才能撤回
                -->
              <el-button
                v-if="!scope.row.isGenReceipt"
                slot="reference"
                v-permit:remove="'btn:receivableManagementSite:toExamine:recall'"
                type="danger"
                size="mini"
              >{{ $t('receivablePayable.withdraw') }}</el-button>
            </el-popconfirm>
          </template>
        </el-table-column>
      </template>
    </el-table>
  </div>
</template>

<script>
import { apiSiteWithdrawById } from '@/api/finance/receivables';
import { CARGO_TYPE } from '@/views/finance/basicData/quotationManagement/cmp/utils';

export default {
  props: {
    // table列
    currentColumns: {
      type: Array,
      default: () => []
    },
    // 动态列
    getCurrentColumns: {
      type: Array,
      default: () => []
    },
    // 表格数据
    tableData: {
      type: Array,
      default: () => []
    },
    pageSize: {
      type: Number,
      default: 10
    },
    pageNumber: {
      type: Number,
      default: 1
    },
    // 批次号
    batchNumber: {
      type: String,
      default: ''
    },
    // 显示操作按钮
    isWithdraw: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      CARGO_TYPE,
      tableHeight: 200,
      tableKey: new Date().getTime()
    };
  },
  watch: {
    tableData: {
      handler() {
        this.tableKey = new Date().getTime();
      },
      deep: true
    }
  },
  created() {
    this.tableHeight = document.body.clientHeight - 280;
  },
  mounted() {
    // 页面加载的时候设置table的高度
    this.tableHeight = document.body.clientHeight - 280;
    // 页面大小该变的时候（缩放页面）设置table的高度（可加可不加）
    window.onresize = () => {
      this.tableHeight = document.body.clientHeight - 280;
    };
  },
  methods: {
    // 勾选
    handleSelectionChange(arr) {
      this.$emit('selection-change', arr);
    },
    // 撤回
    recall(row) {
      console.log(row);
      apiSiteWithdrawById({
        orderNumber: row.orderNumber,
        businessNumber: row.waybillNumber,
        billBatchNumber: this.batchNumber
      }).then(res => {
        if (res.code === 200) {
          this.$message.success(this.$t('basicData.TheOperationSucceeded'));
          this.$emit('query-page');
        }
      });
    }
  }
};
</script>

<style scoped>
/* 设置列宽超出... */
::v-deep .ellipsis > .cell {
  width: 100% !important;
}
::v-deep .ellipsis > .cell > div {
  width: 100% !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
}
</style>
